<style lang="scss" src='./ProvisioningStep2.scss' scoped ></style>
<template src="./ProvisioningStep2.html"></template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'ProvisioningStep2',
  data() {
    return ({
      sensor: null,
      models: ['GX-1A','GX-1F'],
      model: 'GX-1A',
    });
  },
  computed: {
    ...mapState(['course']), 

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
  },

  methods: {
    ...mapMutations('SensorProvisioning', ['setCanBack', 'setCanContinue', 'setProvisionPayload']),

    getSuggestedDepth() {
      if(this.course && this.course.measurement_system && this.course.measurement_system == 'METRIC'){
        return '30 cm';
      }
      return '12\"';
    },
    
    async validateForm() {
      const valid = await this.$refs.validator.validate().then((v) => v);
      return valid;
    },

    async continue() {
      const valid = await this.validateForm();
      if (valid) {
        const provisionPayload = {};

        provisionPayload.model = this.model;
        this.setProvisionPayload(provisionPayload);
      }

      return valid;
    },
  },

  beforeCreate() {},

  created() {},

  activated() {
    this.setCanContinue(this.continue);
    this.setCanBack(null);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
  },
};
</script>
